module.exports = __webpack_public_path__ + "static/media/location4.3d2bb9e3.webp";